import { render, staticRenderFns } from "./remarkName.vue?vue&type=template&id=2a3be40c&"
import script from "./remarkName.vue?vue&type=script&lang=js&"
export * from "./remarkName.vue?vue&type=script&lang=js&"
import style0 from "./remarkName.vue?vue&type=style&index=0&id=2a3be40c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports